import { render, staticRenderFns } from "./InvitationNotification.vue?vue&type=template&id=0c6d1b5a&scoped=true"
import script from "./InvitationNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvitationNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvitationNotification.vue?vue&type=style&index=0&id=0c6d1b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d1b5a",
  null
  
)

export default component.exports